<mpro-dropdown
  title="Spending/Income group "
  [inputValue]="inputValue"
  (openDropdownAction)="onDropdownOpened()"
>
  <ng-container *ngIf="!addNew.isOpen">
    <div *ngFor="let group of userGroups">
      <ng-container *ngIf="group.group.length">
        <mpro-dropdown-item
          class="title-label"
          [isDropdown]="true"
          [dropdownOpen]="group.dropdownOpen"
          (itemClicked)="userGroupsClicked(group)"
          (arrowClicked)="userGroupsClicked(group)"
          [leftText]="'YOUR ' + group.type.toLocaleUpperCase()"
        ></mpro-dropdown-item>
        <ng-container *ngIf="group.dropdownOpen">
          <mpro-dropdown-item
            *ngFor="let g of group.group"
            [actions]="true"
            [leftText]="g.compactDisplayValue()"
            [middleText]="g.name"
            (itemClicked)="onGroupClicked(g, false)"
            (editClicked)="onEditClicked(g)"
            (deleteClicked)="onDeleteClicked(g)"
            [selected]="isGroupSelected(g)"
          ></mpro-dropdown-item>
        </ng-container>
        <hr />
      </ng-container>
    </div>
    <p class="m-0 p-1 p-2">STANDARD GROUPS</p>
    <div
      class="my-1 px-2"
      (mouseleave)="hideDropdowns([spendingGroup, incomeGroup])"
    >
      <mpro-dropdown
        #spendingGroup
        title="Spending groups"
        [horizontal]="true"
        (mouseenter)="toggleDropdowns([spendingGroup, incomeGroup])"
      >
        <mpro-spending-group-container
          [inputValue]="dataFilters.spendingGroup.compactDisplayValue()"
          [systemGroups]="spendingGroups"
          (groupClicked)="onGroupClicked($event, false)"
        ></mpro-spending-group-container>
      </mpro-dropdown>
      <mpro-dropdown
        #incomeGroup
        title="Income groups"
        [horizontal]="true"
        (mouseenter)="toggleDropdowns([incomeGroup, spendingGroup])"
      >
        <div
          *ngIf="
            !(authService.permissions$ | async)?.isFreemium || false;
            else lockIncomeGroups
          "
        >
          <mpro-dropdown-item
            class="system-group"
            *ngFor="let g of incomeGroups"
            [leftText]="g.compactDisplayValue()"
            (itemClicked)="onGroupClicked(g, false)"
            [selected]="false"
          >
          </mpro-dropdown-item>
        </div>
        <ng-template #lockIncomeGroups>
          <mpro-dropdown-item
            class="system-group"
            *ngFor="let g of incomeGroups"
            blockOnClickEvent
            [condition]="true"
            [callback]="authService.openFreemiumRequestModal"
            [leftText]="g.compactDisplayValue()"
            [showLock]="true"
            [selected]="false"
          >
          </mpro-dropdown-item>
        </ng-template>
      </mpro-dropdown>
    </div>
    <div class="new-btn-wrapper">
      <button
        blockOnClickEvent
        [condition]="(authService.permissions$ | async)?.isFreemium || false"
        [requestCategory]="'New spending group'"
        [callback]="authService.openFreemiumRequestModal"
        class="mpro-btn mpro-btn-primary new-btn"
        (click.checkBlockEvent)="
          newGroup.emit(); setAddNew(true, rangeFilterType.SPENDING)
        "
        stopClickPropagation
      >
        <fa-icon [icon]="faPlus"></fa-icon>
        <span>New Spending Group</span>
        <fa-icon
          *ngIf="
            !authService.isLoggedIn() ||
            (authService.permissions$ | async)?.isFreemium
          "
          [icon]="faLock"
        ></fa-icon>
      </button>
      <button
        blockOnClickEvent
        [condition]="(authService.permissions$ | async)?.isFreemium || false"
        [requestCategory]="'New income group'"
        [callback]="authService.openFreemiumRequestModal"
        class="mpro-btn mpro-btn-primary new-btn"
        (click.checkBlockEvent)="
          newGroup.emit(); setAddNew(true, rangeFilterType.INCOME)
        "
        stopClickPropagation
      >
        <fa-icon [icon]="faPlus"></fa-icon>
        <span>New Income Group</span>
        <fa-icon
          *ngIf="
            !authService.isLoggedIn() ||
            (authService.permissions$ | async)?.isFreemium
          "
          [icon]="faLock"
        ></fa-icon>
      </button>
    </div>
  </ng-container>
  <mpro-dialog-box
    class="mpro-box"
    *ngIf="addNew.isOpen"
    (save)="onSave($event)"
    (preview)="onPreview($event)"
    (cancel)="onCancel()"
    [title]="'Create ' + addNew.group.toLocaleLowerCase() + ' Group'"
    inputTitle="Name"
    subtitle="Drag the slider or enter your desired spending range in the fields below."
    [rangeFilter]="inEditSpendingGroup"
    [min]="0"
    [max]="
      addNew.group === rangeFilterType.INCOME
        ? maxIncomeGroup
        : maxSpendingGroup
    "
    [minInterval]="1"
    [labelFormat]="labelFormat"
    [customSteps]="
      addNew.group === rangeFilterType.INCOME
        ? customIncomeSteps
        : customGroupSteps
    "
  ></mpro-dialog-box>
  <mpro-delete-modal
    [(open)]="isDeleteModalOpen"
    [resourceName]="spendingGroupForDeletion?.name || ''"
    (onDelete)="onDelete()"
  >
  </mpro-delete-modal>
</mpro-dropdown>
